import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { LoginHero } from '@/components/login/login-hero'
import { AuthForm } from '@/components/login/auth-form'
import { getSessionUser } from '@/lib/server/auth'

const LoginPage: FC = (): ReactNode => {
    return (
        <Layout className='bg-ink'>
            <Seo
                title='Accedi'
                description='Accedi ad Approdo e trova ogni giorno le aziende e gli annunci di lavoro in linea con il tuo profilo.'
            />

            <div className='relative h-[clamp(300px,50dvh,460px)] shrink-0'>
                <LoginHero />
            </div>

            <section
                aria-label='Accesso'
                className='relative z-10 -mt-8 flex-1 animate-in rounded-t-[32px] bg-white duration-700 ease-out fade-in slide-in-from-bottom-8'
            >
                <AuthForm />
            </section>
        </Layout>
    )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
    try {
        const user = await getSessionUser(req)

        if (user) return { redirect: { destination: '/', permanent: false } }
    }
    catch (error) {
        console.error('[accedi] session check failed', error instanceof Error ? error.message : error)
    }

    return { props: {} }
}

export default LoginPage
